import { ColumnsType } from "antd/es/table";
import { ColumnType } from "antd/lib/table";
import TableRowField from "components/fields/TableRowField";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { namePathOrMatcher } from "utils/formUtils";
import { renderTableDateNoTimezoneColumn } from "utils/tableUtils";

import { PresalePasswordsListFieldValue } from "../../types";

import { UsePresalePasswordsTable } from "./types";

const usePresalePasswordsTableColumns = (
  actionsColumn?: ColumnType<PresalePasswordsListFieldValue>
) => {
  const intl = useIntl();

  return useMemo<ColumnsType<PresalePasswordsListFieldValue>>(
    () => [
      {
        title: intl.formatMessage({
          defaultMessage: "Name",
        }),
        dataIndex: "name",
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Password",
        }),
        dataIndex: "password",
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Expire Date",
        }),
        dataIndex: "expireAt",
        render: renderTableDateNoTimezoneColumn("expireAt"),
      },
      ...(actionsColumn ? [actionsColumn] : []),
    ],
    [intl, actionsColumn]
  );
};

export const usePresalePasswordsTable: UsePresalePasswordsTable = ({
  actionsColumn,
  dataSource,
  ...props
}) => {
  const columns = usePresalePasswordsTableColumns(actionsColumn);

  return {
    ...props,
    columns,
    dataSource,
    components: { body: { row: TableRowField } },
    onRow(_data, index) {
      if (index === undefined) {
        return {};
      }

      return {
        matcher: namePathOrMatcher({
          equals: [["input", "presalePasswords"]],
          startsWith: [["input", "presalePasswords", index]],
        }),
      } as React.HTMLAttributes<unknown>;
    },
  };
};
